<div class="approvals_section">
    <div class="row">
        <div class="col-md-4">
            <app-rules-sidebar [rules]="rules" (selectedRoleIdEmitter)="selectedRoleIdHandler($event)"
                (updateRuleNameEmitter)="updateRoleNameHandler($event)" *ngIf="contentPageVisible"
                (deleteData)="deleteDataHandler($event)" [selectedRule]="selectedRule"
                (refreshData)="refreshDataHandler($event)" [ruleconfigureForm]="ruleconfigureForm"
                [ruleValues]="ruleValues"></app-rules-sidebar>
        </div>
        <div class="col-md-8">
            <app-rules-content [rules]="rules" *ngIf="contentPageVisible" [selectedRule]="selectedRule"
                (ruleConfigureForm)="ruleConfigureFormHandler($event)" (refreshData)="refreshDataHandler($event)"
                [ruleConfigureFormGroup]="ruleconfigureForm" (enableDisableEmitter)="enableDisableHandler($event)"
                [ruleValues]="ruleValues"></app-rules-content>
        </div>
    </div>
</div>